(function ($) {
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    function calculate_loan(L, n, r) {
        //'Formula --> P = L[(r/12)(1+(r/12))^n]/[(1+(r/12))^n-1]

        // R is a percent
        r = r / 100;
        // Adding variables to make the formula easier to read
        var toPower = 1 + ( r / 12 ), power = Math.pow( toPower, n );
        var calc = L * ( ( r / 12 ) * power ) / ( power - 1 );
        return calc && isFinite(calc) ? formatter.format( calc.toFixed(2) ) : ' --';
    }

    function get_rate( amount ) {
        let rate = 0;
        for ( let i in ThemeJS.Variables.loan_bracket ) {
            if ( amount >= ThemeJS.Variables.loan_bracket[i].loan_amount ) {
                rate = ThemeJS.Variables.loan_bracket[i].interest_rate;
            }
        }

        return parseFloat(rate);
    }

    function watch_fields( THAT ) {
        var L, n, r;
        var parent = $( THAT ).parents('.loan_calculator');

        L = parseFloat( $( ".loan_amount", parent ).val().replace(/\D/, '').replace(/\,/gi, "").replace(/\%/gi, "") );
        n = parseFloat( $( ".loan_months", parent ).val().replace(/\D/, '').replace(/\,/gi, "").replace(/\%/gi, "") );
        // r = parseFloat( $( ".loan_rate", parent ).val().replace(/\,/gi, "").replace(/\%/gi, "") );
        r = get_rate( L );
        console.log(L, n, r);

        $( ".loan_rate", parent ).val( r + "%" );

        if ( L && n && r ) {
            $( ".loan_payment", parent ).val( calculate_loan(L, n, r) );
        } else {
            $( ".loan_payment", parent ).val( "$ --" );
        }
    }

    $(document).on("input", ".loan_amount, .loan_months, .loan_rate", function() {
        watch_fields( this );
    });

    $(function() {
        ThemeJS.Variables.loan_bracket.sort(function(a, b) {
            if (a.loan_amount < b.loan_amount) return -1;
            if (a.loan_amount > b.loan_amount) return 1;
            return 0;
        });

        $(".loan_amount").each(function() {
            var numberMask = IMask(this, {
                mask: '$num',  // enable number mask
                overwrite: true,
                lazy: false,
                blocks: {
                    num: {
                        mask: Number,
                        scale: 2,  // digits after point, 0 for integers
                        signed: false,  // disallow negative
                        thousandsSeparator: ',',  // any single char
                        normalizeZeros: true,  // appends or removes zeros at ends
                        radix: '.',  // fractional delimiter
                        mapToRadix: ['.'],  // symbols to process as radix
                        min: 0,
                        max: 100000000000
                    }
                },
            });
        });
        
        $(".loan_months").each(function() {
            var numberMask = IMask(this, {
                mask: 'num',  // enable number mask
                overwrite: true,
                lazy: false,
                blocks: {
                    num: {
                        mask: Number,
                        scale: 2,  // digits after point, 0 for integers
                        signed: false,  // disallow negative
                        thousandsSeparator: ',',  // any single char
                        normalizeZeros: true,  // appends or removes zeros at ends
                        radix: '.',  // fractional delimiter
                        mapToRadix: ['.'],  // symbols to process as radix
                        min: 0,
                        max: 600
                    }
                },
            });
        });
        
        $(".loan_rate").each(function() {
            var numberMask = IMask(this, {
                mask: 'num%',  // enable number mask
                overwrite: true,
                lazy: false,
                blocks: {
                    num: {
                        mask: Number,
                        scale: 2,  // digits after point, 0 for integers
                        signed: false,  // disallow negative
                        thousandsSeparator: ',',  // any single char
                        normalizeZeros: true,  // appends or removes zeros at ends
                        radix: '.',  // fractional delimiter
                        mapToRadix: ['.'],  // symbols to process as radix
                        min: 0,
                        max: 100
                    }
                },
            });
        });
    });
})(jQuery);